/*
  Emitted Events:
    dynamic-select-change (scopedField) emitted whenever a scoped field is reinitialized
      detail: {
        el: the scopedField that triggered the event
      }
*/

import { createCustomEvent } from '../../../../../javascript/shared/helpers';

export default class extends Controller {

  connect() {
    this.scopables.forEach(this.initializeFields.bind(this));
  }

  initializeFields({ scoped, scoping, url }) {
    const scopedField = this.element.querySelector(scoped);
    const scopingField = this.element.querySelector(scoping);
    scopingField.setAttribute('data-select-options-base-url', url);
    App.DynamicSelect.onChange(scopingField, (() => this.getNewOptionsFor({ scopingField, scopedField })).bind(this));
    App.DynamicSelect.onChange(scopedField, () => this.triggerChangeEvent(scopedField));
  }

  getNewOptionsFor({ scopingField, scopedField }) {
    App.DynamicSelect.disable(scopedField);
    App.Helpers.ajaxRequest({
      url:            this.getURLFrom(scopingField),
      successHandler: res => this.reinitializeScopedField({ scopedField, res }),
      errorHandler:   () => this.reinitializeScopedField({ scopedField, res: '' })
    });
  }

  reinitializeScopedField({ scopedField, res }) {
    scopedField.innerHTML = res;
    App.DynamicSelect.initEl(scopedField);
    App.DynamicSelect.enable(scopedField);
    App.DynamicSelect.setValue(null);
    this.triggerChangeEvent(scopedField)
  }

  triggerChangeEvent(scopedField) {
    scopedField.dispatchEvent(createCustomEvent('dynamic-select-change', scopedField));
  }

  getURLFrom(scopingField) {
    return scopingField.dataset.selectOptionsBaseUrl.replace(/\$ID_PLACEHOLDER/g, scopingField.value);
  }

  //
  // GETTERS AND SETTERS
  //

  get scopables() {
    return JSON.parse(this.data.get('scopables')) || [];
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/forms-fields-scoped-select-controller.js